import { Box, Link, NeoColor, P4, Stack } from "@noom/wax-component-library";

import { TreatmentCardStateContainer } from "./TreatmentCardStateContainer";

type TreatmentCardErrorProps = {
  message: string;
  retryLabel: string;
  onRetry: () => void;
};

export const TreatmentCardError = ({
  message,
  retryLabel,
  onRetry,
}: TreatmentCardErrorProps) => (
  <TreatmentCardStateContainer>
    <Box width="100%" height="85px" bg={NeoColor.greyscale.gray1} />
    <Stack p={4}>
      <P4 color={NeoColor.greyscale.black}>
        {message}{" "}
        <Link
          href="#"
          color={NeoColor.blue.lagoon}
          fontSize="inherit"
          fontWeight="medium"
          lineHeight="inherit"
          cursor="pointer"
          onClick={(event) => {
            event.preventDefault();
            onRetry();
          }}
        >
          {retryLabel}
        </Link>
      </P4>
    </Stack>
  </TreatmentCardStateContainer>
);
